import {GridColDef, GridRenderCellParams} from '@mui/x-data-grid';
import {t} from 'i18next';
import {Box} from '@mui/material';
import ArrButton from '../../common/arr-button/ArrButton';

interface GetProjectFieldListGridColumnsProps {
  handleEdit?: (projectId: string) => void;
  handleActivateDeactivate?: (params: GridRenderCellParams) => void;
}

export const getProjectFieldListGridColumns = (
  props: GetProjectFieldListGridColumnsProps
): GridColDef[] => {
  return [
    {
      field: 'projectFieldName',
      headerName: t('manageProjectFields.gridColumns.fieldName'),
      flex: 3,
      headerClassName: 'typo-text label2_size',
      renderCell: (param: GridRenderCellParams) => {
        return (
          <Box
            className="manageProjectFields-cell"
            tabIndex={0}
            role="gridcell"
          >
            {param.value}
          </Box>
        );
      },
    },
    {
      field: 'dataType',
      headerName: t('manageProjectFields.gridColumns.dataType'),
      flex: 3,
      headerClassName: 'typo-text label2_size',
      renderCell: (param: GridRenderCellParams) => {
        return (
          <Box
            className="manageProjectFields-cell"
            tabIndex={0}
            role="gridcell"
          >
            {param.value}
          </Box>
        );
      },
    },
    {
      field: 'isSet',
      headerName: t('manageProjectFields.gridColumns.isTallyable'),
      flex: 3,
      headerClassName: 'typo-text label2_size',
      renderCell: (params: GridRenderCellParams) => {
        const raw = params.row.isSet == null ? '' : String(params.row.isSet);
        const display = raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : raw;

        return (
          <Box
            className="manageProjectFields-cell"
            tabIndex={0}
            role="gridcell"
          >
            {display}
          </Box>
        );
      },
    },
    {
      field: 'isSearchable',
      headerName: t('manageProjectFields.gridColumns.isSearchable'),
      flex: 3,
      headerClassName: 'typo-text label2_size',
      renderCell: (params: GridRenderCellParams) => {
        const raw =
          params.row.isSearchable == null
            ? ''
            : String(params.row.isSearchable);
        const display = raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : raw;

        return (
          <Box
            className="manageProjectFields-cell"
            tabIndex={0}
            role="gridcell"
          >
            {display}
          </Box>
        );
      },
    },
    {
      field: 'isActive',
      headerName: t('manageProjectFields.gridColumns.isActive'),
      flex: 3,
      headerClassName: 'typo-text label2_size',
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box
            tabIndex={0}
            role="gridcell"
            className={`status ${params.row.isActive ? 'active' : 'inactive'} manageProjectFields-cell`}
          >
            {params.row.isActive ? t('common.active') : t('common.inactive')}
          </Box>
        );
      },
    },
    {
      field: '',
      headerName: t('manageCommentFields.gridColumns.actions'),
      flex: 3,
      headerClassName: 'typo-text label2_size',
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box
            className={`edit-project-field-${params.row.projectFieldId} manageProjectFields-cell`}
          >
            <ArrButton
              dataTestId={`edit-project-field-${params.id}`}
              variant="secondary"
              size="xs"
              onClick={() =>
                props.handleEdit?.(params.row.projectFieldId.toString())
              }
              onKeyDown={(e) => {
                if (e.code === 'Space') {
                  e.stopPropagation();
                  props.handleEdit?.(params.row.projectFieldId.toString());
                }
              }}
            >
              {t('common.edit')}
            </ArrButton>
            <ArrButton
              dataTestId={`deactivate-project-field-${params.id}`}
              variant="secondary"
              size="xs"
              disabled={params.row.isActive ? params.row.isSystemField : false}
              onClick={() => {
                props.handleActivateDeactivate?.(params.row);
              }}
              onKeyDown={(e) => {
                if (e.code === 'Space') {
                  e.stopPropagation();
                  props.handleActivateDeactivate?.(params.row);
                }
              }}
            >
              {params.row.isActive
                ? t('common.deactivate')
                : t('common.activate')}
            </ArrButton>
          </Box>
        );
      },
    },
  ];
};
